import * as React from 'react';
import styled from 'styled-components';
const Login = styled.div`
margin-bottom: 5px;
background-color: #005daa;
border-radius: 5px;
-moz-border-radius: 5px;
-webkit-border-radius: 5px;
padding: 10px 0;
text-align: center;
        & h3 {
            margin-bottom: 15px;
  color: #fefefe;
  font: 1.4em Arial, Helvetica, sans-serif;
        }
        & .button {
            font-size: 1.2rem;
            font-weight: 700;
            line-height: 1.5;
            position: relative;
            display: inline-block;
            padding: 4px 2.5rem;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            text-align: center;
            vertical-align: middle;
            text-decoration: none;
            letter-spacing: 0.1em;
            border-radius: 4px;
            color: #005daa;
            background: linear-gradient(to bottom, #fdfbfb 0%, #ebedee 100%);
            & :hover{
                background: linear-gradient(to bottom, #ebedee 0%, #ebedee 100%);
            }
        }
`
const MembersLogin = () => {
  return (
    <Login>
      <h3>会員専用</h3>
      <button className="button"
        onClick={() => window.open('/members_only', '', 'width=1200,height=900,scrollbars=yes')}>ログイン</button>
    </Login>
  );
};

export default MembersLogin;
